export const URL_PREFERENCES = "/settings";
export const URL_HOME = "/";
export const URL_SAVED_TEXTS = "/texts";
export const URL_HISTORY = "/history";
